module.exports = __webpack_public_path__ + "img/img1.f9cc4c9c.png";